// extracted by mini-css-extract-plugin
export default {"iconExpand":"IconExpand_iconExpand__4sYhU"};